export const messages = {
  startPageTitle: "LDS Participant Registry",
  startPageApplyCardTitle: "Join the European Language Data Space",
  startPageApplyButton: "Apply",
  startPageApplyCard: "Apply to join the European Language Data Space",
  startPageLoginLongText:
    "If you represent an <b>approved organisation</b>, you can sign in to view and update your information, and to register and manage your connectors.<p>As an <b>LDS GB member</b>, you can sign in to view applicants, assess their applications, and manage LDS participants and their technical components.</p>",
  startPageLoginCard: "Enter the LDS participant registry",
  startPageApplyLongText:
    "You can apply on behalf of your organisation to join LDS. Provide the required information and accept the <a target='blank' href='https://language-data-space.ec.europa.eu/about/lds-beta/general-terms-and-conditions-testing-language-data-space_en'>LDS Terms & Conditions</a>.The LDS Governance Board will assess your eligibility (for the current phase, LDS is restricted to EU-based organisations). <p>If <b>approved</b>, you will receive instructions on how to access the LDS ecosystem.</p>",
  startPageLoginButton: "Login",
  footerAboutHeading: "About",
  footerAboutLink: "Learn more about the European Language Data Space",
  participantFormTitle: "Participant Registration Form",
  participantFormSubTitle: "Join the Common European Language Data Space.",
  participantFormOrgGroup: "Organisation info",
  participantFormConcentTextBefore:
    "I acknowledge that I have read, understood, and agree to be bound by the",
  participantFormTitleConcentTextAfter: "LDS General Terms and Conditions",
  participantFormPersonalDataBefore:
    "For any information regarding the processing of your personal data, please refer to the ",
  participantFormPersonalDataStatement: "Privacy Statement.",
  //
  registryHomeSuspendDialogTitle: "Suspend participation",
  registryHomeSuspendDialogAsk: "Are you sure you want to suspend your participation ?",

  registryHomeAdminTitle: "Participant Registry Management Console",
  registryHomeAdminSubTitle: "Here you can manage all participants.",
  registryHomeGBMemberSubTitle: "Here you can view all participants.",
  registryHomeUserTitle: "Participant Management Console",
  registryHomeUserSubTitle: "Here you can review your organisation profile.",
  registryHomeOverviewTitle: "Registration Overview",
  registryHomeConnectorViewTitle: "Connector Overview",
  registryHomeConnectorViewSubTitle: "Overview organisation connectors.",
  registryHomeConnectorViewbutton: "View list of connectors",
  registryHomeNewConnectorButton: "Register a connector",
  registryHomeConnectorCreationTitle: "Connector Creation",
  registryHomeConnectorCreationSubTitle: "Configure organisation connectors.",
  registryHomeAdminCardTitle: "View list of participants",
  registryHomeAdminCardSubTitle: "View details of all registered participants.",
  participnatListPageTitle: "Participant List",
  registryHomeParticipantCardSubTitle:
    "Review and update your organisation's registration information.",
  registryHomeEditButton: "Edit Organisation Info",
  registryHomeViewButton: "View Organisation Info",
  registryHomeEditDocumentsButton: "Edit Organisation documents",
  registryHomeRequestTerminationButton: "Request termination",
  registryHomeRequestTerminationSnackbarSuccess: "Request for termination submitted successfully!",
  registryHomeRequestTerminationSnackbarError: "Failed to terminate participant.",
  registryHomeRequestSuspensionButton: "Request suspension",
  registryHomeRequestUnSuspensionButton: "Request unsuspension",
  registryHomeUnsuspendUser: "Unsuspend participant",
  registryHomeTerminateUser: "Terminate participant",
  registryHomeUnsuspendUserAsk:
    "Are you sure you want to request reinstating your organisation?",
  registryHomeTerminateUserAsk:
    "Are you sure you want to terminate your participation ?",
  registryHomeSubmitSuspension: "Submit request for suspention",
  registryHomeSubmitUnSuspension: "Submit request to unsuspend",
  registryHomeSubmitTermination: "Submit request for termination",
  //
  registryHomeSubmitUnSuspendSuccess: "Your reinstatement request has been submitted successfully!",
  registryHomeSubmitUnSuspendError: "Failed to reinstated participant.",
  //
  connectorListDelete: "Delete connector",
  cancel: "Cancel",
  close: "Close",
  delete: "Delete",
  modify: "Modify entry",
  actions: "Actions",
  confirm: "Confirm",
  submit: "Submit",
  connectorEdit: "Edit",
  participantCardTitle: "Details for: ",
  participantListManage: "Manage Status",
  participantListAcceptTerminateAction: "Accept/Decline Termination",
  participantListAcceptUnsuspensionAction: "Accept/Decline Unsuspension",
  participantListAcceptSuspensionAction: "Accept/Decline Suspension",
  participantListTerminateAction: "Terminate",
  participantListSuspendAction: "Suspend",
  participantListRejectAction: "Reject",
  participantListShowReasonAction: "Show reason",
  participantListExportButton: "Export selected participants",
  connectorListExportButton: "Export selected connectors",
  dialogShowReasonTitle: "Reason",
  participantListBackToPendingAction: "Reinstate to PENDING",
  participantListBackToApprovedAction: "Reinstate to APPROVED",
  participantDetailsNA: "N/A",
  participantDetailsID: "ID",
  participantDetailsCreatedAt: "Created",
  participantDetailsApproveSnackbarSuccess: "Participant approved successfully!",
  participantDetailsApproveSnackbarError: "Failed to approve participant.",
  participantDetailsExportSnackbarError:  "Failed to export participants.",
  participantDetailsApproveStatus: "Approval status",
  participantDetailsApprovedAt: "Approved",
  participantDetailsNameOptIn: "Display name in central catalogue",
  participantDetailsAdminEditButton: "Edit participant",
  participantDetailsAdminEditDocumentsButton: "Edit participant documents",
  removeDocumentDialogConfirm: "Yes, remove",
  removeDocumentDialogTitle: "Remove document",
  removeDocumentDialogAsk: "Are you sure you want to remove this file?",
  participantDetailsUserEditButton: "Edit my info",
  catalogueAsk: "Would you like your organisation name to be visible in the",
  catalogueAskLinkText: "LDS catalogue of participants",
  catalogueAskNote:
    "After you are approved, you can change this setting at any time.",
  participantFormOptInMessage: "Yes",
  participantFormOptOutMessage: "No",
  paticipantFormValidationErrors: "Validation notices",
  participantListEmptyConnectors: "No connectors",
  participantListUnmameParticipant: "Unnamed participant",
  //
  dialogTitleReject: "Reject Participant",
  dialogRejectAsk: "Are you sure you want to reject participant",
  dialogTextFieldRejectReason: "Reason for rejection",
  dialogTextUnsuspensionReason: "Reason for unsuspension",
  dialogRejectSubmit: "Submit Rejection",
  //
  participantDetailsRejectSnackabarSuccess: "Participant rejected successfully!",
  participantDetailsRejectSnackabarError: "Failed to reject participant.",
  participantDetailsReinstateSnackabarSuccess: "Participant Reinstated successfully!",
  participantDetailsReinstateSnackabarError: "Failed to Reinstate participant.",
  //
  dialogTitleReinstate: "Reinstate (Approve) participant",
  dialogReinstateAsk: "Are you sure you want to reinstate participant",
  dialogTitleReinstateBack: "Reinstate (back to pending) participant",
  dialogReinstateBackAsk: "Are you sure you want to reinstate participant",
  //
  dialogTitleDelete: "Delete participant",
  dialogDeleteAsk: "Are you sure you want to delete participant",
  //
  dialogTitleApprove: "Approve participant",
  dialogApproveAsk: "Are you sure you want to approve participant",
  dialogApproveSubmit: "Submit Approval",
  //
  dialogTitleSuspend: "Suspend participant",
  dialogSuspendAsk: "Are you sure you want to suspend participant",
  dialogTextFieldSuspendReason: "Reason for suspension",
  dialogSuspendSubmit: "Submit suspension",
  //
  participantDetailsSuspendSnackabarSuccess: "Participant suspended successfully!",
  participantDetailsSuspendSnackabarError: "Failed to suspend participant.",
  participantDetailsEvaluateStatusChangeSnackbarSuccess: "Participant request sent successfully!",
  participantDetailsEvaluateStatusChangeSnackbarError: "Failed to suspend participant.",
  participantDetailsEvaluateStatusSentSnackbarError: "Failed to sent the request.",
  participantDetailsWithdrawSnackbarSuccess: "Participant withdrawn successfully!",
  participantDetailsWithdrawSnackbarError: "Failed to withdraw participant.",
  participantDetailsDeleteSnackbarSuccess: "Participant deleted successfully!",
  participantDetailsDeleteSnackbarError: "Failed to delete participant.",
  participantDetailsRequestDeclineDeleteSnackbarSuccess: "Your request to delete the connector has been declined",
  participantDetailsRequestDeclineDeleteSnackbarError: "Failed to delete connector.",
  participantDetailsRequestDeleteSnackbarSuccess: "Request for connector deletion submitted successfully!",
  participantDetailsRequestDeclineDeleteSnackbarError: "Failed to send request for connector deletion.",
  connectorEvaluateDeleteSnackbarSuccess: "Connector deletion request has been accepted",
  connectorEvaluateDeclineDeleteSnackbarError: "Connector deletion request has been declined",
  //
  dialogTitleRequestSuspend: "Request to suspend participant",
  dialogRequestSuspendAsk:
    "Do you want to accept the request for suspension for",
  dialogSuspendAcceptSubmit: "Accept Suspension",
  dialogSuspendDeclineSubmit: "Decline Suspension",
  //
  dialogTitleRequestUnSuspend: "Request to unsuspend participant",
  dialogTitleUnSuspend: "Unsuspend participant",
  dialogRequestUnSuspendAsk:
    "Do you want to accept the request for unsuspension for",
  dialogUnSuspendAcceptSubmit: "Accept Unsuspension",
  dialogUnSuspendDeclineSubmit: "Decline Unsuspension",
  //
  dialogTitleTerminate: "Terminate participant",
  dialogTerminateAsk: "Are you sure you want to terminate participant",
  dialogTextFielTerminateReason: "Reason for termination",
  dialogTerminateSubmit: "Submit termination",
  //
  dialogTitleRequestTerminate: "Request to terminate participant",
  dialogRequestTerminateAsk:
    "Do you want to accept the request for termination for",
  dialogTerminateAcceptSubmit: "Accept termination",
  dialogTerminateDeclineSubmit: "Decline termination",
  //
  connectorDeleteReasonLabel: "Reason for deletion",
  connectorDeleteAsk: "Are you sure you want to delete connector ",
  connectorDeleteAction: "Delete connector",
  connectorDeleteRequestAsk:
    "Are you sure you want to request the deletion of connector ",
  conncectoDeleteRequest: "Delete connector request",
  conncectoDeleteRequestButton: "Request Connector Deletion",
  connectorDeleteRequestAcceptAsk:
    "Do you want to accept the request for deletion for ",
  connectorDeleteRequestAccept: "Accept request for deletion",
  connectorDeleteAcceptButton: "Accept deletion",
  connectorDeleteDeclineButton: "Decline deletion",
  //
  fillAllMessage: "Please fill out all required fields",
  //
  connectorsRequestDelete: "Request connector deletion",
  connectorsRequestApproveRejectDelete: "Approve/Reject Deletion Request",
  connectorManage: "Manage Connector",
  // upload documents
  documentUploadAreaTitle: "Related documents",
  participantLandingPageGoToDocumentsButton: "Update related documents",
  documentDownloadButton: "Download",
  documentDownloadButtontTooltip: "Download file",
  backToParticipantListButtonLabel: "Back to participant list",
  uploadFileSizeWarning: "File should not exceed 20MB",
  addDocumentButton: "Add a document",
  removeDocumentButton: "Remove this document",
  updateDocumentButton: "Update document",
  updateDocumentRequiredMessage:
    "Please fill out all required elements to proceed",
  updateDocumentRequiredAfterButtonMessage:
    "Please fill out all required elements on the left to proceed",
  updateSelectDocumentButton: "Replace file",
  updateSelectDocumentTooltipButton: "Choose a new file to replace or upload",
  ducumentTopHelpUpdateDocumentText:
    "You can replace the existing file by choosing a new one and clicking 'Update document'.",
  ducumentTopHelpNewDocumentText:
    "Select a file that supports the organisation's eligibility and click 'Upload Document'.",
  uploadDocumentButton: "Upload document",
  documentPermitedFiles: "Select file (pdf, png, jpg, jpeg)",
  docTitleFieldLabel: "Title",
  docDescriptionFieldLabel: "Description",
  docTitleFieldHelpText: "Please enter the document title",
  docDescriptionFieldHelpText:
    "Please enter a brief description of the document",
  step1Title: "Participant details",
  step2Title: "Document Upload",
  completeStep1Message:
    "Please submit your registration before continuing to this step",
  eucontroledSectionTitle: "Please certify your EU-control status to access offers limited to EU-controlled entities",
  eucontroledQuestion: "Are you EU-controlled* ?",
  eucontroledFirstNote:
  "<b>”Control”</b> is defined as the possibility to exercise decisive influence on the participant, directly or indirectly, through one or more intermediate entities, 'de jure' or 'de facto'. The fact that no influence is actually exercised is not relevant, as long as the possibility exists. For ownership control restrictions, a participant will be considered to be ‘non-EU controlled’ when a shareholder/partner/member/owner who is a non-EU country/non-EU entity/non-EU national, at any level in the chain of control (including intermediate layers), has the possibility (‘de jure’ or ‘de facto’) to exercise decisive influence on the entity concerned, notably in relation to its strategic business decisions (such as appointment and removal of senior management, decisions regarding budget, investment business plans, market-specific decisions, etc).",
  eucontroledSecondNote:
 "Please note that if the Language Data Space has reasonable doubt to disagree with the declared EU-control, they can at any given time remove access to offers of the Language Data Space that are visible only for EU-controlled entities.",
 eucontroledApprovalFormTitle: "Validate EU status",
 EUControlledValidatedLabel: "Verified as EU-controlled",
 LLMs4EUValidatedLabel: "Verified as LLMs4eu partner",
 EUControlledValidatedhelperText: "Control means the ability to exercise decisive influence over an entity, directly or indirectly.",
 llmsPartnerApprovalFormLabel: "Is this organisation an llms4eu partner?",
 llmsPartnerApprovalhelperText: "Click yes if this organisation is an llms4eu partner?",
 yesLabelParticipantForm: "Yes",
 noLabelParticipantForm: "No",
 yesLabelEUControledApprovalForm: "Verified as EU-controlled",
 noLabelEUControledApprovalForm: "Verified as not EU-controlled",
 dialogEditEUTagTitle: "Edit EU status",
 eucontroledEditFormTitle: "Edit the EU control status",
 dialogEditEUTagAsk: "Are you sure you want to change the EU control status for ",
 dialogEditLLMs4euPartnerAsk: "Are you sure you want to change the LLMs4euPartner status for ",
 dialogEditEUTagSubmit: "Submit",
 dialogEditLLMs4euPartnerSubmit: "Submit",
 LLMs4euPartnerEditFormTitle: "Edit the LLMs4euPartner status",
 dialogEditLLMs4euPartnerSnackbarSuccess: "Participant LLMs4euPartner updated successfully!",
 dialogEditLLMs4euPartnerSnackbarSuccess: "Participant LLMs4euPartner updated successfully!",
 dialogEditEUTagSnackbarSuccess: "Participant EU Tag updated successfully!",
 dialogEditEUTagSnackbarError: "Failed to update EU Tag for participant.",
 dialogEditLLMs4euPartnerSnackbarError: "Failed to update LLMs4euPartner status for participant.",
 ocaProjectQuestionPartA: "If yes and if you have previously undergone an Ownership and Control Assessment (OCA) in connection to an EU programme/call, please indicate the PIC number of your organisation:",
 ocaProjectQuestionPartB: "as well as the relevant project identifier and/or title:",
 ocaSectionTitle: "Previous OCA details",
 messagesBroadcast_title: "messagesBroadcastTitle",
 messagesBroadcast_recipients: "Recipients: ",
 messagesBroadcastPage_title: "Broadcast Logs",
 messagesBroadcast_promt_partA: "Broadcast Message to",
 messagesBroadcast_promt_partB: "Connectors",
 messagesBroadcast_button: "Compose Broadcast",
 ListofConnectors_Top_broadcast_button: "Send Broadcast Message",
 broadcastList_title: "Broadcast History",
 connectorListPageTitle: "List of connectors",
 connectorListPageSubTitle: "View details of all registered connectors",
 boradcastInfoMessageTootip: "Please select active, non-deleted connectors from the list to send a broadcast.",
 updateBannerText: "The new LDS version will be released on September 2nd. In preparation for the release, the LDS Registry and the LDS Catalogue will undergo maintenance from Friday August 28th until Wednesday September 2nd, which may temporarily affect their availability and technical stability. We apologise for any inconvenience this may cause and appreciate your understanding."
};
